import AddHistoryImages from "./AddHistoryImages";
import AddHistoryForm from "./AddHistoryForm";
import React from "react";

const AddHistoryBody = ({handleInputChange, formData, screenShot, screenShotReady, summaryImageElement}) => {

  const screenShotProps = { screenShot, screenShotReady, summaryImageElement };

  return (
    <div className={"detail-design-history-body"}>
      <div className={"detail-design-history-inner edit"}>
        <AddHistoryImages {...screenShotProps}/>
        <AddHistoryForm handleInputChange={handleInputChange} formData={formData}/>
      </div>
    </div>
  )
}


export default AddHistoryBody;
